// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "@firebase/firestore";
const firebaseConfig = {
    apiKey: "AIzaSyC5RNjMGW5l9_E6OpukA_eUVpk3wxAaomY",
    authDomain: "hinducafe-android.firebaseapp.com",
    projectId: "hinducafe-android",
    storageBucket: "hinducafe-android.appspot.com",
    messagingSenderId: "442048407819",
    appId: "1:442048407819:web:8154f9aa8a06c710d99a0e",
    measurementId: "G-FZRBRRFH0G"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
// const analytics = getAnalytics(app);